function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C8.46875 0 8.9375 0.1875 9.28125 0.53125L15.4688 6.71875C15.8125 7.0625 16 7.53125 16 8C16 8.46875 15.8125 8.9375 15.4688 9.28125L9.28125 15.4688C8.9375 15.8125 8.46875 16 8 16C7.53125 16 7.0625 15.8125 6.71875 15.4688L0.53125 9.28125C0.1875 8.9375 0 8.46875 0 8C0 7.53125 0.1875 7.0625 0.53125 6.71875L6.71875 0.53125C7.0625 0.1875 7.53125 0 8 0ZM8 10C7.4375 10 7 10.4375 7 11C7 11.5625 7.4375 12 8 12C8.5625 12 9 11.5625 9 11C9 10.4375 8.5625 10 8 10ZM8 4C7.4375 4 6.96875 4.5 7.03125 5.0625L7.25 8.3125C7.28125 8.6875 7.59375 9 8 9C8.40625 9 8.71875 8.6875 8.75 8.3125L8.96875 5.0625C9.03125 4.5 8.5625 4 8 4Z",
  fill: "#FDB71A"
});

function SvgSubmittedDataFair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedDataFair);
export default __webpack_public_path__ + "static/media/submitted-data-fair.b59f0dec.svg";
export { ForwardRef as ReactComponent };